import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'

import { SelectAccount } from '@components/SelectAccount'
import type { Entity } from '@models/Entity'

import type { AccountOption } from '../../types/AccountOption'

const accountFields: {
  label: string
  field: keyof AccountOption
}[] = [
  { label: 'Naam', field: 'naam' },
  { label: 'Rol', field: 'rol' },
  { label: 'Organisatie', field: 'contactOrganisatie' },
  { label: 'Telefoonnummer', field: 'telefoonnummer' },
  { label: 'Emailadres', field: 'emailadres' },
]

interface Props {
  entity: Entity
  account: AccountOption | null
  onAccountChange: (account: AccountOption | null) => void
  error?: boolean
}

export function CreateAccountFields({
  entity,
  account,
  onAccountChange,
  error,
}: Props) {
  return (
    <Box>
      <SelectAccount
        sx={{ pr: 1, pb: 1 }}
        entity={entity}
        value={account}
        onChange={onAccountChange}
        error={error}
        fullWidth
      />
      {account &&
        accountFields.map(({ label, field }) => (
          <TextField
            key={field}
            sx={{ pr: 1, pb: 1 }}
            value={account[field]}
            variant="standard"
            label={label}
            fullWidth
            disabled
          />
        ))}
    </Box>
  )
}
